<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12" offset-lg="0">
        <b-card class="reports">
          <div
            slot="header"
            style="display:flex; justify-content: space-between;"
          >
            <HeaderTitle title="Download Reports"></HeaderTitle>
          </div>
          <b-row>
            <b-col
              style="display:flex; justify-content:center"
              v-for="report in reportList"
              :key="report.id"
              lg="4"
            >
              <CustomButton
                @triggerDownload="
                  n => download(n, report.url, report.params, report.fileName)
                "
                :loading="isLoading"
                :name="report.name"
                :type="report.type"
                :icon="report.icon"
              >
              </CustomButton>
            </b-col
            >

          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import CustomButton from "../../../components/shared/CustomButton.vue";
import DateModal from "../../../components/shared/DateModal.vue";
import HeaderTitle from "../../../components/shared/HeaderTitle.vue";
import LoadingCard from "../../../components/shared/LoadingCard.vue";
import router from "../../../router";
import {from, isUserLoggedIn, to} from "../../../utils/Utils";

export default {
  name: "TechnicalReports",
  components: {
    Datepicker,
    router,
    DateModal,
    HeaderTitle,
    LoadingCard,
    CustomButton
  },
  data() {
    return {
      from: from,
      to: to,
      reportList: [],
      locationsIds: "",
      isLoading: {loading: false, type: ""},
      modalDate: false,
      dateFrom: "",
      dateTo: ""
    };
  },
  methods:
    {
    download(type, url, parameters, fileName) {
      this.isLoading = {loading: true, type: type};
      let params = parameters
        ? {
          date_from: this.dateFrom,
          date_to: this.dateTo
        }
        : {};

      this.$http.get(url, {params, responseType: "blob"}).then(
        res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName + ".xlsx");
          document.body.appendChild(link);
          link.click();
          this.isLoading = {loading: false, type: ""};
        },
        err => {
          this.isLoading = {loading: false, type: ""};
          console.log(err);
        }
      );
    },

    modalDateEvent() {
      this.$bvModal.show("technical_reports");
    }
  },
  mounted() {
    let range = 3
    const crtYear = new Date().getFullYear()

    for (let i = range-1; i >= 0; i--) {
      const year = crtYear-i
      this.reportList.push({
        id: range-i,
        type: year,
        url: "tracker_private/spreadsheets/PBRSDynamic.php?year=" + year,
        name: "Report for " + year,
        fileName: "SummaryReport_" + year,
        params: false,
        icon: "fa fa-file-excel-o"
      })
    }
    isUserLoggedIn(router);
    this.locationsIds = localStorage.getItem("locations");
  }
};
</script>

<style>
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}

.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
</style>
